import postPath from './postPath';
import { gql } from '../../graphql/generated/gql';
import type { DocumentType } from '../../graphql/generated/gql';
import { isFeatureEnabled } from '../features';

const THREAD_FRAGMENT = gql(`
  fragment commentThreadPath_thread on ThreadFields {
    id
    resolvedAt
    version
    post {
      ...postPath_post
    }
  }
`);

const commentThreadPath = (thread: DocumentType<typeof THREAD_FRAGMENT>) => {
  if (!thread.post) return undefined;
  const anchor = `thread-${thread.id}`;

  if (isFeatureEnabled('history_v2')) {
    return postPath(thread.post, {
      histories: thread.resolvedAt
        ? `${thread.version}-${thread.version + 1}`
        : undefined,
      anchor,
    });
  }

  return `${postPath(thread.post)}${thread.resolvedAt ? '/comments' : ''}#${anchor}`;
};

export default commentThreadPath;
